import { TabExtraProps } from "./TabExtra.interface"

export const TabExtra = <T = any,>(props: TabExtraProps<T>) => {
  const { className, children } = props

  return <div className={`ml-auto self-center ${className}`}>{children}</div>
}
